import request from "@/utils/request";

/* 预约回电 */
export const getArticle = (params) => {
  return request({
    url: "/open-road/api/qqw-website/settings/list",
    params,
  });
};
